import { render, staticRenderFns } from "./DecisionSales.vue?vue&type=template&id=24d543a4&"
import script from "./DecisionSales.vue?vue&type=script&lang=js&"
export * from "./DecisionSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports